<template>
  <section class="landing-header-container">
    <div class="content-wrapper">
      <div class="text-area">
        <div class="title">
          <div class="fokos">fokos</div>
          <p>21</p>
        </div>
        <div class="subtitle">
          Egy rendkívüli történelemmel rendelkező harci fegyver XXI. századi újragondolása.
        </div>
        <a href="#" v-scroll-to="'#scrollto-preorder'" class="preorder-btn">előrendelés</a>
      </div>
      <div class="hero"></div>
    </div>
  </section>
</template>

<script>
export default {
  name: "LandingPage"
}
</script>

<style scoped>
.landing-header-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  position: relative;
  background: url(../assets/background_elements/lowpoly_texture.png) no-repeat center;
  background-size: cover;
}



.content-wrapper {
  display: flex;
  align-items: flex-end;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.text-area {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 10%;
  padding-bottom: 10vh;
  height: 100%;
  width: 40%;
}

.title {
  display: flex;
  font-size: max(5vw, 64px);
  user-select: none;
}

.fokos {
  font-weight: 900;
  text-transform: uppercase;
  margin-right: 0.25em;
}

.subtitle {
  font-size: max(1.5vw, 20px);
  color: #444444;
  line-height: 1.3em;
  margin-bottom: 1.5em;
}

.preorder-btn {
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #EFBE3E;
  height: 3vw;
  min-height: 40px;
  width: 40%;
  min-width: 150px;
  box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.25);
  text-transform: uppercase;
  font-weight: bold;
  border-radius: 5px;
  font-size: max(1vw, 13px);;
}

.preorder-btn:hover {
  box-shadow: 3px 6px 10px rgba(0, 0, 0, 0.35);
}

.hero {
  height: 50vw;
  max-height: 90vh;
  width: 60%;
  background-image: url("../assets/brand_photos/hero.png");
  background-position: left;
  background-repeat: no-repeat;
  background-size: cover;
}

a {
  text-decoration: none;
  color: inherit;
}

@media only screen and (max-width: 1400px) {
  .landing-header-container {
    height: auto;
  }

  .content-wrapper {
    align-items: center;
  }

  .text-area {
    padding-bottom: 0;
  }
}

@media only screen and (max-width: 900px) {
  .hero {
    width: 50%;
  }

  .text-area {
    width: 50%;
  }
}

@media only screen and (max-width: 700px) {
  .text-area {
    width: 100%;
  }

  .hero {
    display: none;
  }

  .content-wrapper {
    padding: 100px 7%;
    justify-content: center;
  }

  .text-area {
    width: 100%;
    padding: 0;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .title {
    font-size: 60px;
  }

  .subtitle {
    font-size: 22px;
    margin-top: 0.5rem;
    width: 80%;
    max-width: 350px;
  }

  .landing-header-container {
    height: auto;
  }

  .preorder-btn {
    font-size: 18px;
    width: 200px;
    height: 50px;
  }
}

</style>
